import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { ChatsPageComponent } from './chats-page.component';
import { ChatsListComponent } from '../../components/chat/chats-list/chats-list.component';
import { ChatPageComponent } from './chat-page/chat-page.component';
import { NewPollComponent } from './chat-page/new-poll/new-poll.component';
import { CreateMessageComponent } from '../../components/chat/message-creation/create-message/create-message.component';
import { MessageTextComponent } from '../../components/chat/message-creation/message-text/message-text.component';
import { MessageFileComponent } from '../../components/chat/message-creation/message-file/message-file.component';
import { MessageBuildingComponent } from '../../components/chat/message-creation/message-building/message-building.component';


const routes: Routes = [{
  path: 'chats', // Ð¼Ð¾Ð¶Ð½Ð¾ 'chats' Ð¸Ð»Ð¸ ''
  component: ChatsPageComponent,
  children: [
    // {
    //   path: '',
    //   component: ChatsListComponent
    // },
    // {
    //   path: ':chatId',
    //   component: ChatPageComponent
    // },
    // {
    //   path: ':chatId/new-poll',
    //   component: NewPollComponent,
    // },
    {
      path: 'list',
      children: [
        {
          path: '',
          component: ChatsListComponent
        },
        {
          path: ':chatId',
          component: ChatPageComponent
        },
        {
          path: ':chatId/new-poll',
          component: NewPollComponent,
        },
      ],
    },

    {
      path: 'create-message',
      component: CreateMessageComponent,
    },
    {
      path: 'message-text',
      component: MessageTextComponent,
    },
    {
      path: 'message-file',
      component: MessageFileComponent,
    },
    {
      path: 'message-building',
      component: MessageBuildingComponent,
    },
  ],
}];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class ChatsPageRoutingModule { }
